import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const CalonMhsService = {}

CalonMhsService.getData = function (token,id_pendaftar) {

    return fetch({
        url: '/transaksi/pendaftar',
        method: 'get',
        params: {
            id_pendaftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.getDataDetail = function (token,konfirmasi=false) {

    return fetch({
        url: '/transaksi/detailpendaftar',
        method: 'get',
        params: {
            konfirmasi
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.konfirmasi = function (token,data) {
    return fetch({
        url: '/transaksi/pendaftar/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postDetail = function (token,data) {
    return fetch({
        url: '/transaksi/detailpendaftar/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.getDataByUser = function (token,id_user_daftar) {

    return fetch({
        url: '/transaksi/pendaftarbyuser',
        method: 'get',
        params: {
            id_user_daftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postSimpanPermanen = function (token,data) {
    return fetch({
        url: '/transaksi/pendaftar/simpanpermanen',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.delete = function (token,data) {
    return fetch({
        url: '/transaksi/pendaftar/delete',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.hasil = function (token,data) {
    return fetch({
        url: '/transaksi/pendaftar/hasil',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postPendidikan = function (token,data) {
    return fetch({
        url: '/transaksi/pendidikan/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postJasAlm = function (token,data) {
    return fetch({
        url: '/transaksi/jas_almamater/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postPekerjaan = function (token,data) {
    return fetch({
        url: '/transaksi/pekerjaan/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postAkunUM = function (token,data) {
    return fetch({
        url: '/transaksi/akunum/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.postDefer = function (token, data) {
    return fetch({
        url: '/transaksi/pendaftar/defer/store',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY
        }
    })
}

export default CalonMhsService;
